// extracted by mini-css-extract-plugin
export default {"iconStyles":"iconsStyles_iconStyles__0oly9"};